import portraitImage from '$lib/assets/jarle.jpg';
import socialImage from '$lib/assets/social-card.png';

export const site = {
	name: 'Jarle Mathiesen',
	title: 'Writing',
	author: 'Jarle Mathiesen',
	url: 'https://mathiesen.dev',
	description: 'Writing on software engineering, AI, and the systems behind good products.',
	portraitImage,
	socialImage
} as const;

export function absoluteUrl(path = '/') {
	return new URL(path, site.url).toString();
}
